import { Box } from "@mui/material";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { AccountsandFinanceurl } from "../../../../config";
import { SuppliersColumns } from "../../../../data/DynamicTable/Collumns";
import {
  allSuppliers,
} from "../../../../data/Axios/queries";
import SupplierForm from "./form";

const base_url = AccountsandFinanceurl.uri;

const actions = {
  entity: "Suppliers",
 // isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },
  viewJournalEntries: { // New action for journal entries
    key: "VIEW_JOURNAL_ENTRIES",
    button_name: "View Journal Entries",
   Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
    query: "anyJournalLinesByColumnValues", // Query to fetch journal entries
    inputFields: (row) => ({ 
      identifierId: row.id,
      identifierType: 2,
      cancelled: null,
    }),
    returnFields: [
      "journalLineID",
      "journalEntryID",
      "accountID",
      "debit",
      "credit",
      "description",
      "createdDate",
      "caseId",
      "applicationId",
      "applicationType",
    ],
  },
  showStatus: true,
};

function SuppliersTable() {
  return (
    <Box m="1px">
      <DynamicTable
        title="Suppliers"
        subtitle="Create, view or edit suppliers"
        columns={SuppliersColumns}
        FormComponent={SupplierForm}
        query={allSuppliers}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
}

export default SuppliersTable;